<template>
  <div style="margin-top: -40px !important" v-if="recipe">
    <head>
      <link
        href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"
        rel="stylesheet"
      />
      <!--      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet">-->
      <!--      <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">-->
      <!--      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">-->
    </head>
    <b-container>
      <!-- Successful recipe share modal -->
      <b-modal id="modal-1" ok-only title="Success">
        <p class="my-2">This recipe is shared with the user you have chosen!</p>
      </b-modal>
      <b-modal id="modal-2" ok-only title="Success">
        <p class="my-2">
          This recipe is shared with the group you have chosen!
        </p>
      </b-modal>

      <!-- Share Recipe  Modal -->
      <b-modal
        @cancel="hideModal"
        @ok="handleOk"
        id="modal-prevent-closing"
        ok-title="Share"
        ok-variant="danger"
        ref="modal"
        v-bind:title="'Share this recipe ' + this.title"
      >
        <form @submit.stop.prevent="handleSubmit" ref="form">
          <div class="container">
            <b-form-group
              label="Do you wish to share this recipe with a single user or a group?"
            >
              <!--      <b-form-radio-group id="radio-group-2" v-model="selected" @input="showConsole" name="radio-sub-component">-->
              <b-form-radio-group
                id="radio-group-2"
                name="radio-sub-component"
                v-model="selected"
              >
                <b-form-radio value="a">a single user</b-form-radio>
                <b-form-radio value="b">a group</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="this.selected === 'a'">
              <p class="my-2">Whom would you like to share this with?</p>
              <Autocomplete :EventBus="sendChosenLogin1"></Autocomplete>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyLoginAlert"
                variant="danger"
              >
                This UserName is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="notFoundUserAlert"
                variant="danger"
              >
                An error occurred! Maybe the UserName you submitted does not
                exist!
              </b-alert>
            </b-form-group>

            <b-form-group
              label="Which group would you like to share this recipe with?"
              label-align="left"
              v-if="this.selected === 'b'"
            >
              <b-form-input
                placeholder="Enter the Group name"
                style="width: 100%"
                v-model="GroupChosen"
              >
              </b-form-input>

              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyGroupNameAlert"
                variant="danger"
              >
                This group name is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="notFoundGroupAlert"
                variant="danger"
              >
                An error occured! Maybe the group you submitted does not exist!
              </b-alert>
            </b-form-group>
          </div>

          <hr />

          <b-form-group
            class="col-12"
            label="What right will you grant to this user?"
            label-align="left"
          >
            <b-form-select :options="Rights" v-model="right"> </b-form-select>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="emptyRightAlert"
              variant="danger"
            >
              You have to specify the right!
            </b-alert>
          </b-form-group>
        </form>
      </b-modal>

      <div class="mt-lg-5" v-if="recipe">
        <!-- Basic information -->
        <VueHtml2pdf
          :show-layout="false"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="recipe.title"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="800px"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <div class="container center text-center align-content-center">
              <h1 class="text-center">Recipe Title: {{ recipe.title }}</h1>
              <h3 class="text-center">
                Recipe Description: {{ recipe.description }}
              </h3>
              <p style="float: right">Creator: {{ recipe.creator.login }}</p>
            </div>
          </section>
        </VueHtml2pdf>
        <div class="row pt-4 pb-4 bg-white border-custom-lgr">
          <div class="col-lg-5 col-sm-5 col-md-5 col-xs-12">
            <!-- If user has chosen an existing file during recipe creation -->
            <div class="text-left p-3" v-if="this.imageResourceUrl">
              <span>
                <b-img
                  :src="this.imageResourceUrl"
                  class="mb-2"
                  fluid-grow
                ></b-img
                ><br />
              </span>
            </div>
            <div class="text-left p-3" v-if="this.recipe.bannerUrl">
              <!-- If the user has uploaded a new file during recipe creation -->
              <span>
                <b-img
                  :src="this.recipe.bannerUrl"
                  class="mb-2"
                  fluid-grow
                ></b-img
                ><br />
              </span>
            </div>
            <!-- if not img -->
            <div class="text-left p-5 bg-gray" id="image-container" v-else>
              <div class="col-4"></div>
              <div class="col-4 pl-lg-5">
                <span class="pl-lg-5">
                  <font-awesome-icon
                    icon="book-reader"
                    size="10x"
                  ></font-awesome-icon>
                </span>
              </div>
              <div class="col-4"></div>
            </div>
            <div class="text-muted text-left p-3">
              <span
                title="Creation date of the recipe"
                v-b-tooltip.hover.bottom
              >
                <font-awesome-icon icon="calendar-alt" />
                {{ recipe.created | utcLocalDatetime }}
              </span>
            </div>
            <div
              v-if="this.$store.state.user.login !== this.recipe.creator.login"
            >
              <div
                v-if="!this.ratingSubmitted ? 'background-color: green' : null"
                class="pl-3 row"
              >
                <div>
                  <p style="font-weight: bold">
                    {{
                      initialRating === ""
                        ? "Rate this recipe:"
                        : "Your rating:"
                    }}
                  </p>
                </div>
                <div>
                  <v-app
                    style="height: 50px; margin-top: -20px; background: white"
                  >
                    <div class="text-left">
                      <v-rating
                        v-model="userRating"
                        background-color="orange lighten-3"
                        color="orange"
                        large
                      ></v-rating>
                    </div>
                  </v-app>
                </div>
              </div>
              <div
                v-if="!this.ratingSubmitted"
                style="z-index: 3; position: relative; margin-top: -10px"
                class="pl-3 row"
              >
                <b-form-textarea
                  v-model="userRatingComment"
                  placeholder="Say something about this recipe"
                ></b-form-textarea>
                <b-button
                  @click="submitRating"
                  class="col-3 mt-1 bg-orange"
                  size="sm"
                >
                  {{ initialRating === "" ? "Submit " : "Edit your " }}rating
                </b-button>
              </div>
              <p
                v-if="ratingSubmitted"
                class="text-left mt-1 pl-3"
                style="color: green"
              >
                Submitted!
              </p>
            </div>
          </div>
          <div class="col-lg-7 col-sm-7 col-md-7 col-xs-12">
            <div class="p-3">
              <h4 class="text-left mb-4">
                <strong style="overflow-wrap: break-word">{{
                  recipe.title
                }}</strong>
                <span v-show="isEditable || isDeletable"> |</span>
                <small>
                  <router-link
                    :to="{
                      name: 'recipeEdit',
                      params: { id: this.$route.params.id },
                    }"
                    title="Edit the recipe"
                    v-b-tooltip.hover.top
                    v-show="isEditable"
                  >
                    <b-button class="btn btn-sm btn-dark">
                      <font-awesome-icon icon="edit" />
                      Edit
                    </b-button>
                  </router-link>
                  <b-link
                    @click.prevent="showMsgDelete(recipe.id, recipe.title)"
                    class="text-danger"
                    title="Delete the recipe"
                    v-b-tooltip.hover.top
                    v-show="isDeletable"
                  >
                    <b-button class="btn btn-sm btn-danger">
                      <font-awesome-icon icon="trash-alt" />
                      Delete
                    </b-button>
                  </b-link>
                  <b-link
                    class="text-info"
                    title="Share the recipe"
                    v-b-tooltip.hover.top
                    v-show="isShareable"
                  >
                    <b-button
                      @click="ShareThisRecipe"
                      class="btn btn-sm btn-info"
                    >
                      <font-awesome-icon icon="share-alt" />
                      Share
                    </b-button>
                  </b-link>
                  <b-link
                    class="text-info"
                    title="Clone the recipe"
                    v-b-tooltip.hover.top
                    v-show="isCloneable"
                  >
                    <b-button
                      @click="cloneRecipe(recipe.id)"
                      class="btn btn-sm btn-success"
                    >
                      <font-awesome-icon icon="clone" />
                      Clone
                    </b-button>
                  </b-link>
                  <b-link
                    class="text-white"
                    title="Favorite"
                    v-b-tooltip.hover.top
                  >
                    <span
                      @click="handleBookmarkRecipe(recipe)"
                      class="container"
                    >
                      <i
                        style="color: red"
                        :class="
                          recipe.bookmarked ? 'fas fa-heart' : 'far fa-heart'
                        "
                      ></i>
                    </span>
                  </b-link>
                  <!--                  <b-link class="text-info"-->
                  <!--                          title="Download the recipe"-->
                  <!--                          v-b-tooltip.hover.top>-->
                  <!--                    <b-button @click="generateReport" class="btn btn-sm btn-warning">-->
                  <!--                      <font-awesome-icon icon="download"/>-->
                  <!--                      Download-->
                  <!--                    </b-button>-->
                  <!--                  </b-link>-->
                </small>
              </h4>
              <div class="row">
                <v-app
                  style="height: 50px; margin-top: -20px; background: white"
                >
                  <div class="text-left">
                    <v-rating
                      v-model="averageRating"
                      background-color="orange lighten-3"
                      color="orange"
                      large
                      readonly
                      half-increments
                    ></v-rating>
                  </div>
                </v-app>
                <div class="pl-2">
                  <p>
                    Average rating: <strong>{{ averageRatingStars }}/5</strong>
                  </p>
                </div>
                <div class="pl-2 mb-4">
                  <b-link @click.prevent="scrollTo('ratings')" href="#">
                    <button
                      @click="getRatings"
                      class="btn btn-sm btn-outline-info"
                    >
                      See ratings
                    </button>
                  </b-link>
                </div>
              </div>
              <h4 class="text-left mb-4">
                <span title="Added by" v-b-tooltip.hover.bottom>
                  <font-awesome-icon icon="user-cog" size="1x" />
                  {{ recipe.creator.login }}
                </span>
              </h4>
              <p class="text-left mb-4">
                <span
                  title="Duration of the recipe"
                  v-b-tooltip.hover.bottom
                  v-show="recipe.duration"
                >
                  <font-awesome-icon icon="clock" size="lg" />
                  {{ recipe.duration }}
                </span>
                <span
                  title="Cost of the recipe"
                  v-b-tooltip.hover.bottom
                  v-show="recipe.cost"
                >
                  <font-awesome-icon class="ml-4" icon="euro-sign" size="lg" />
                  {{ recipe.cost }}
                </span>
              </p>
              <p class="text-left mb-4">
                <span
                  title="Number of participants"
                  v-b-tooltip.hover.bottom
                  v-show="recipe.numberOfParticipants"
                >
                  <font-awesome-icon icon="users" size="lg" />
                  {{ recipe.numberOfParticipants }}
                </span>
                <span
                  class="ml-4"
                  title="Visibility of the recipe"
                  v-b-tooltip.hover.bottom
                  v-show="recipe.visibility"
                >
                  <span class="font-weight-bold">Visibility:</span>
                  {{ visibility }}
                </span>
                <span
                  class="text-left mb-4"
                  title="Is the recipe completed?"
                  v-b-tooltip.hover.bottom
                >
                  <font-awesome-icon :icon="isRecipeImplemented" size="lg" />
                  <span v-if="this.recipe.implemented === true">Completed</span>
                  <span v-else>Ongoing or new idea</span>
                </span>
              </p>
              <p
                v-if="
                  (recipe.url && recipe.url.startsWith('http')) ||
                  recipe.url.startsWith('www')
                "
                class="text-left mb-4"
              >
                <span>
                  <b-button
                    v-b-tooltip.hover.bottom
                    title="Route to the URL"
                    class="btn bg-orange btn-sm"
                    :href="getRecipeLink()"
                    target="_blank"
                    >Route to the website
                    <font-awesome-icon icon="angle-right" size="lg" />
                  </b-button>
                </span>
              </p>
              <p
                v-if="
                  recipe.url &&
                  !recipe.url.startsWith('http') &&
                  !recipe.url.startsWith('www')
                "
                class="text-left mb-4"
              >
                <span>
                  <b-button
                    v-b-tooltip.hover.bottom
                    title="The currently provided URL does not route to a valid address."
                    class="btn bg-orange btn-sm"
                    target="_blank"
                    >Route to the website
                    <font-awesome-icon icon="angle-right" size="lg" />
                  </b-button>
                </span>
              </p>
              <p class="text-left mb-4" id="description-container">
                <strong>Description</strong>:
                <span
                  style="white-space: pre-wrap; overflow-wrap: break-word"
                  >{{ recipe.description }}</span
                >
                <br />
                <br />
                <span v-if="recipe.tips">
                  <strong>Tips</strong>:
                  <span
                    style="white-space: pre-wrap; overflow-wrap: break-word"
                    >{{ recipe.tips }}</span
                  >
                </span>
              </p>
              <p class="text-left" title="Keywords" v-b-tooltip.hover.left>
                <Keywords
                  type="recipe"
                  id="keywords-list"
                  v-bind:keywords="recipe.keywords"
                ></Keywords>
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="row mt-3 bg-white">
          <div
            class="col-lg-4 col-sm-4 col-md-12 col-xs-12 pt-3 border-custom-lgr min-h-250 col-container"
          >
            <!-- collaborators -->
            <h4 class="text-left pl-3">Collaborators</h4>
            <hr />
            <!-- Collaborators with ID -->
            <div class="mb-2" v-if="recipe.collaboratorsWithId">
              <div
                class="pl-3 pr-3 pb-0"
                v-bind:key="collaborator.name"
                v-for="collaborator in recipe.collaboratorsWithId"
              >
                <p class="text-left">
                  <span
                    :title="collaborator.type"
                    style="overflow-wrap: break-word"
                    v-if="collaborator.name"
                    v-b-tooltip.hover.bottom
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="landmark"
                    ></font-awesome-icon>
                  </span>
                  <span
                    :title="collaborator.description"
                    style="overflow-wrap: break-word"
                    v-if="collaborator.name"
                    v-b-tooltip.hover.bottom
                  >
                    <router-link
                      :to="{
                        name: 'organizationView',
                        params: { id: collaborator.id },
                      }"
                    >
                      <span
                        style="overflow-wrap: break-word"
                        v-if="collaborator.name"
                      >
                        {{ collaborator.name }}
                      </span>
                      <span v-else> {{ collaborator.type }} </span>
                    </router-link>
                  </span>
                </p>
              </div>
            </div>
            <!-- Collaborators without ID -->
            <div class="mb-2" v-if="recipe.collaborators">
              <div
                class="pl-3 pr-3 pb-0"
                v-bind:key="collaborator.name"
                v-for="collaborator in recipe.collaborators"
              >
                <p class="text-left">
                  <span
                    :title="collaborator.type"
                    style="overflow-wrap: break-word"
                    v-if="collaborator.name"
                    v-b-tooltip.hover.bottom
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="landmark"
                    ></font-awesome-icon>
                  </span>
                  <span
                    :title="collaborator.type"
                    style="overflow-wrap: break-word"
                    v-if="!collaborator.name"
                    v-b-tooltip.hover.bottom
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="landmark"
                    ></font-awesome-icon>
                  </span>
                  <span
                    :title="collaborator.description"
                    style="overflow-wrap: break-word"
                    v-if="collaborator.name"
                    v-b-tooltip.hover.bottom
                  >
                    {{ collaborator.name }}
                  </span>
                  <span v-else> {{ collaborator.type }}</span>
                </p>
              </div>
            </div>
            <!-- No collaborators (no collaborators with ID && no collaborators without ID - the field recipe.collaborators
            is always returned, so instead of checking its existence, we shall check its length because it is an array) -->
            <div
              v-if="
                !recipe.collaboratorsWithId && recipe.collaborators.length === 0
              "
            >
              <p class="text-left p-3">No collaborators have been defined</p>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-4 col-md-12 col-xs-12 pt-3 border-custom-lgr min-h-250 col-container"
          >
            <!-- areas of focus -->
            <h4 class="text-left pl-3">Areas of focus</h4>
            <hr />
            <div v-if="recipe.areasOfFocus">
              <div
                class="pl-3 pr-3 pb-0"
                v-bind:key="topic"
                v-for="topic in recipe.areasOfFocus"
              >
                <p v-if="topic !== 'Other'" class="text-left">
                  <font-awesome-icon
                    class="mr-2"
                    icon="hand-point-right"
                    size="lg"
                  ></font-awesome-icon>
                  {{ topic }}
                </p>
              </div>
            </div>
            <div v-else>
              <p class="text-left p-3">Not defined</p>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-4 col-md-12 col-xs-12 pt-3 border-custom-lgr min-h-250"
          >
            <!-- target group  -->
            <h4 class="text-left pl-3">Target Groups</h4>
            <hr />
            <div v-if="recipe.targetGroup">
              <div v-bind:key="group.id" v-for="group in recipe.targetGroup">
                <div class="text-left">
                  <div
                    v-if="type !== 'Other'"
                    class="pl-3 pr-3 pb-0"
                    v-bind:key="type"
                    v-for="type in group.type"
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="caret-right"
                      size="lg"
                    ></font-awesome-icon>
                    {{ type }}
                  </div>
                  <br />
                  <div style="overflow-wrap: break-word" class="text-left">
                    {{ group.description }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="text-left p-3">Not defined</p>
            </div>
          </div>
        </div>

        <br />

        <!-- languages and countries -->
        <div class="row mt-3 pb-1 bg-white border-custom-lgr">
          <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
            <h4 class="text-left pl-3">Countries and Languages</h4>
            <hr />
            <div class="text-left p-3">
              <RecipeCountry :countries="recipe.countries"></RecipeCountry>
              <RecipeLanguage :languages="recipe.languages"></RecipeLanguage>
            </div>
          </div>
        </div>

        <br />

        <!-- ingredients -->
        <div class="row mt-3 bg-white border-custom-lgr">
          <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
            <h4 class="text-left pl-3">Ingredients</h4>
            <hr />
            <div class="pb-3 pl-3">
              <div v-if="recipe.ingredients">
                <div
                  :key="getIngredientKey(ingredient)"
                  v-for="(ingredient, index) in recipe.ingredients"
                >
                  <div class="text-left" v-if="ingredient.resource">
                    <ResourceMedia
                      :resource="ingredient.resource"
                    ></ResourceMedia>
                  </div>
                  <div class="text-left" v-else-if="ingredient.recipe">
                    <RecipeMedia :recipe="ingredient.recipe"></RecipeMedia>
                  </div>
                  <hr v-if="!isLastObject(recipe.ingredients, index)" />
                </div>
              </div>
              <div v-else>
                <div class="text-left">No ingredients defined</div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <!-- steps -->
        <div class="row mt-3 pb-4 bg-white border-custom-lgr">
          <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
            <h4 class="text-left pl-3">Steps</h4>
            <hr />
            <div v-if="stepsExists">
              <div
                :key="step.title"
                class="pl-3 pr-3 pb-0"
                v-for="(step, index) in recipe.steps"
              >
                <RecipeStep :index="index" :step="step"></RecipeStep>
                <hr v-if="!isLastObject(recipe.steps, index)" />
              </div>
            </div>
            <div v-else>
              <p class="text-left p-3">No steps are included.</p>
            </div>
          </div>
        </div>

        <br />

        <!-- challenges -->
        <div class="row mt-3 pb-4 bg-white border-custom-lgr">
          <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
            <h4 class="text-left pl-3">Challenges</h4>
            <hr />
            <div v-if="challengesExists">
              <div
                :key="getChallengesKey(challenge)"
                class="pl-3 pr-3 pb-0"
                v-for="(challenge, index) in recipe.challenges"
              >
                <RecipeChallenge :challenge="challenge"></RecipeChallenge>
                <hr v-if="!isLastObject(recipe.challenges, index)" />
              </div>
            </div>
            <div v-else>
              <p class="text-left p-3">No challenges have been mentioned</p>
            </div>
          </div>
        </div>

        <br />

        <!-- outputs -->
        <div class="row mt-3 pb-4 bg-white border-custom-lgr">
          <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
            <h4 class="text-left pl-3">Outputs</h4>
            <hr />
            <div v-if="outputsExists">
              <div
                :key="getOutputKey(output)"
                class="text-left pl-3 pr-3 pb-0"
                v-for="(output, index) in recipe.outputs"
              >
                <!-- <ResourceMedia :resource="output.resource"></ResourceMedia>-->
                <RecipeOutput :output="output"></RecipeOutput>
                <hr v-if="!isLastObject(recipe.outputs, index)" />
              </div>
            </div>
            <div v-else>
              <p class="text-left p-3">No outputs are included</p>
            </div>
          </div>
        </div>

        <!-- ratings -->
        <div
          ref="ratings"
          v-if="ratingCommentsSectionShow"
          class="row mt-3 pb-4 bg-white border-custom-lgr"
        >
          <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
            <h4 class="text-left pl-3">Ratings</h4>
            <hr />
            <div v-for=" (rating, index) in ratings" :key="index">
              <Rating :rating="rating" :ratingIndex="index" :lastRatingIndex="ratings.length" ></Rating>
              <br>
            </div>
            <div class="overflow-auto" v-if="showPagination">
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.totalCount"
                :per-page="pagination.pageSize"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                align="center"
                @input="getRatings"
              >
              </b-pagination>
            </div>
          </div>
        </div>
        <br>

        <div class="comments">
          <VueDisqus
            v-if="
              recipe.creator !== '' &&
              (recipe.rights === 'OWN' ||
                recipe.rights === 'READ' ||
                recipe.rights === 'WRITE')
            "
            shortname="culturelabs-1"
            :identifier="$route.path"
          />
        </div>
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import Keywords from "../components/Keywords";
import RecipeMedia from "../components/recipes/RecipeMedia";
import RecipeStep from "../components/recipes/RecipeStep";
import RecipeChallenge from "../components/recipes/RecipeChallenge";
import RecipeOutput from "../components/recipes/RecipeOutput";
import ResourceMedia from "../components/resources/ResourceMedia";
import NoAccess from "../components/NoAccess";
import Autocomplete from "./Autocomplete";
import RecipeCountry from "../components/recipes/RecipeCountry";
import RecipeLanguage from "../components/recipes/RecipeLanguage";
import Rating from "../components/Rating";
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import axios from "axios";
import { Disqus } from "vue-disqus";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "recipeView",
  components: {
    Rating,
    RecipeCountry,
    RecipeLanguage,
    Keywords,
    RecipeMedia,
    RecipeStep,
    RecipeChallenge,
    RecipeOutput,
    ResourceMedia,
    Autocomplete,
    NoAccess,
    Disqus,
    VueHtml2pdf,
  },
  data() {
    return {
      ratingSubmitted: false,
      userRating: "",
      initialRating: "",
      userRatingComment: "",
      identifier: "",
      ratings: "",
      ratingCommentsSectionShow: false,
      url: "",
      recipe: {
        creator: "",
        collaboratorsWithId: [],
        bannerUrl: "",
        url: "",
        avgRatingx100: "",
        bookmarked: false
      },
      imageResourceUrl: null,
      emptyLoginAlert: false,
      emptyGroupNameAlert: false,
      emptyRightAlert: false,
      notFoundUserAlert: false,
      notFoundGroupAlert: false,
      sendChosenLogin1: "sendChosenLogin",

      selected: "a",
      GroupChosen: "",
      GroupChosenId: "",

      RecipesType: "Recipe",

      title: "",
      userLogin: null,
      userID: 0,
      right: null,
      users: "",

      Rights: [
        { text: "I will grant the right to ...", value: null },
        { text: "View the recipe", value: "READ" },
        { text: "Edit the recipe", value: "WRITE" },
      ],
      value1: "",

      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      }
    };
  },
  watch: {
    $route(to, from) {
      if (from.params.id && to.params.id) {
        this.$router.go(to);
      }
    },
  },
  created: function () {
    // get the recipe
    this.getRecipe(this.$route.params.id);
    eventBus.$on("sendChosenLogin", (value11) => {
      this.value1 = value11;
    });
    this.getUserRating(this.$route.params.id);
    this.identifier = this.$route.params.id;
    this.url = this.$route.fullPath;
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    // eslint-disable-next-line vue/no-dupe-keys
    identifier() {
      return this.$route.path;
    },
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize;
    },
    averageRating() {
      let rating = this.recipe.avgRatingx100;
      if (rating < 50) return 0;
      else if (rating >= 50 && rating < 100) return 0.5;
      else if (rating >= 100 && rating < 150) return 1;
      else if (rating >= 150 && rating < 200) return 1.5;
      else if (rating >= 200 && rating < 250) return 2;
      else if (rating >= 250 && rating < 300) return 2.5;
      else if (rating >= 300 && rating < 350) return 3;
      else if (rating >= 350 && rating < 400) return 3.5;
      else if (rating >= 400 && rating < 450) return 4;
      else if (rating >= 450 && rating < 500) return 4.5;
      else if (rating === 500) return 5;
    },
    averageRatingStars() {
      if (this.recipe.avgRatingx100 === -1) return "-";
      else return Math.max(0, this.recipe.avgRatingx100 / 100);
    },
    isShared() {
      // check if the recipe is shared
      return this.recipe.isShared;
    },
    isEditable() {
      // check if edit action is allowed
      return this.recipe.rights === "WRITE" || this.recipe.rights === "OWN";
    },
    isDeletable() {
      // check if delete action is allowed
      return this.recipe.rights === "OWN";
    },
    isShareable() {
      // check if share action is allowed
      return this.recipe.rights === "OWN";
    },
    isCloneable() {
      return this.recipe.publicReadable && this.authenticatedUser;
    },
    visibility() {
      return this.recipe.publicReadable === true ? "Public" : "Private";
    },
    isRecipeImplemented() {
      if (this.recipe.implemented === true) {
        return "check-circle";
      } else {
        return "times-circle";
      }
    },
    stepsExists() {
      return this.recipe.steps !== undefined && this.recipe.steps.length > 0;
    },
    challengesExists() {
      return (
        this.recipe.challenges !== undefined &&
        this.recipe.challenges.length > 0
      );
    },
    outputsExists() {
      return (
        this.recipe.outputs !== undefined && this.recipe.outputs.length > 0
      );
    },
    hideBanner2() {
      // Hide the division that displays the collaborators, purposeTopicFocus and targetGroup only
      // and if only these are not defined
      return !(
        this.recipe.collaborators &&
        this.recipe.purposeTopicFocus &&
        this.recipe.targetGroup
      );
    },
    hideBanner3() {
      // Hide the division that displays the collaborators, purposeTopicFocus and targetGroup only
      // and if only these are not defined
      return !(
        this.recipe.ingredients &&
        this.stepsExists() &&
        this.recipe.challenges
      );
    },
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    handleBookmarkRecipe(recipe) {
      if (!recipe.bookmarked) {
        this.$store.dispatch("bookmarkRecipe", recipe.id).then((response) => {
          if (response.status === 200) {
            recipe.bookmarked = true;
          }
        });
      } else {
        this.$store
          .dispatch("deleteBookmarkRecipe", recipe.id)
          .then((response) => {
            if (response.status === 200) {
              recipe.bookmarked = false;
            }
          });
      }
    },
    scrollTo(refName) {
      let element = this.$refs[refName];
      let top = element.offsetTop;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth",
      });
    },
    initRatings() {
      this.ratings = [];
    },
    getRatings() {
      this.ratingCommentsSectionShow = true;
      let params = {
        id: this.$route.params.id,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize,
      };
      // get data
      let tempResources = [];
      this.$store.dispatch("getRecipeCurrentRatings", params).then((data) => {
        tempResources = data;
        this.pagination.totalCount = data.length;
        this.initRatings();
        // adjust rating entities
        tempResources.forEach((rating) => {
          let temp = rating;
          this.ratings.push(temp);
        });
        console.log(this.ratings);
      });
    },
    hideRatingSubmitted() {
      this.ratingSubmitted = false;
    },
    updateAverageRating() {
      this.getRecipe(this.recipe.id);
    },
    submitRating() {
      let ratingObj = {
        recipeId: this.$route.params.id,
        stars: this.userRating,
        comment: this.userRatingComment,
      };
      if (this.initialRating === "") {
        this.$store
          .dispatch("submitRecipeRating", ratingObj)
          .then((response) => {
            // if success, refresh comments
            this.ratingSubmitted = true;
            this.initialRating = this.userRating;
            setTimeout(this.hideRatingSubmitted, 500);
            this.getRatings();
            this.updateAverageRating();
            console.log(response);
          })
          .catch((error) => {
            console.info(error);
          });
      } else {
        this.$store
          .dispatch("deleteRecipeRating", this.$route.params.id)
          .then((response) => {
            this.$store
              .dispatch("submitRecipeRating", ratingObj)
              .then((response) => {
                this.ratingSubmitted = true;
                this.initialRating = this.userRating;
                setTimeout(this.hideRatingSubmitted, 500);
                // if success, refresh comments
                this.getRatings();
                this.updateAverageRating();
                console.log(response);
              })
              .catch((error) => {
                console.info(error);
              });
          });
      }
    },
    getRecipe: function (recipeId) {
      // Fetch the recipe and the resource
      this.$store.dispatch("getRecipeEntity", recipeId).then((entity) => {
        console.log(entity);
        this.recipe = entity;
        this.recipe.isShared = false;
        // recipe bookmark 
        this.$set(this.recipe, 'bookmarked', ( entity.bookmarked || false ))
      });
    },
    getUserRating(id) {
      let ratingInfo = {
        recipeId: id,
        userId: this.$store.state.user.id,
      };
      this.$store
        .dispatch("getRecipeRatingUser", ratingInfo)
        .then((response) => {
          if( response && response.length == 1 ) {
            this.userRating = response[0].stars;
            this.userRatingComment = response[0].comment;
            this.initialRating = this.userRating;
          }
        });
    },
    getRecipeLink() {
      let link = this.recipe.url;
      if (link && link.startsWith("http")) {
        return link;
      } else if (link && link.startsWith("www")) {
        return "https://" + link;
      }
      return "#";
    },
    ShareThisRecipe() {
      this.$bvModal.show("modal-prevent-closing");
    },
    cloneRecipe(id) {
      // let url = '/recipe/clone/' + id
      this.$store
        .dispatch("cloneRecipe", id)
        .then((response) => {
          this.showCloneSuccess();
        })
        .catch((error) => {
          console.info(error);
          this.showCloneSuccess();
        });
    },
    showCloneSuccess() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Your recipe has been successfully cloned.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.$router.push({ name: "recipes" });
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showCloneFail() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Something went wrong. Please try again.", {
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    handleSubmit() {
      if (this.selected === "b") {
        this.emptyRightAlert = false;
        this.emptyGroupNameAlert = false;
        this.notFoundGroupAlert = false;

        // Exit when the form isn't valid
        if (this.GroupChosen === null || this.GroupChosen === "") {
          this.emptyGroupNameAlert = true;
        } else if (this.GroupChosen !== null && this.GroupChosen !== "") {
          this.emptyGroupNameAlert = false;

          axios
            .get("/group/byName?name=" + this.GroupChosen, {
              withCredentials: true,
            })
            .then((response) => {
              this.GroupChosenId = response.data.id;
              this.notFoundGroupAlert = false;
              if (this.right === "" || this.right === null) {
                this.emptyRightAlert = true;
              } else {
                this.SendUserDataToAPI();
              }
            })
            .catch((err) => {
              console.log(err);
              this.emptyGroupNameAlert = false;
              this.notFoundGroupAlert = true;
              this.userID = "";
            });
        }
      }

      if (this.selected === "a") {
        this.emptyRightAlert = false;
        this.emptyLoginAlert = false;
        this.notFoundUserAlert = false;

        // Exit when the form isn't valid
        if (this.value1 === null || this.value1 === "") {
          this.emptyLoginAlert = true;
          this.value1 = "";
        } else if (this.value1 !== null && this.value1 !== "") {
          this.emptyLoginAlert = false;
          axios
            .get("/user/byLogin?login=" + this.value1, {
              withCredentials: true,
            })
            .then((response) => {
              this.userID = response.data.id;
              this.notFoundUserAlert = false;

              if (this.right === "" || this.right === null) {
                this.emptyRightAlert = true;
              } else {
                this.SendUserDataToAPI();
              }
            })
            .catch((err) => {
              console.log(err);
              this.emptyLoginAlert = false;
              this.notFoundUserAlert = true;
              this.userID = "";
            });
        }
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    hideModal() {
      // this.recipeID = 0
      this.value1 = "";
      this.selected = "a";
      this.right = null;
      this.notFoundUserAlert = false;
      this.notFoundGroupAlert = false;
      this.emptyRightAlert = false;
      this.emptyLoginAlert = false;
      this.emptyGroupNameAlert = false;
      this.GroupChosen = "";
    },
    SendUserDataToAPI() {
      if (this.selected === "a") {
        axios
          .post(
            "/share/Recipe/" +
              this.$route.params.id +
              "?userId=" +
              this.userID +
              "&right=" +
              this.right,
            null,
            { withCredentials: true }
          )
          .then((response) => {
            // console.log(response)
            // console.log(' response')
            this.recipeID = 0;
            this.value1 = "";
            this.right = null;
            this.notFoundUserAlert = false;
            this.emptyRightAlert = false;
            this.emptyLoginAlert = false;
            this.$bvModal.hide("modal-prevent-closing");
            this.$bvModal.show("modal-1");
          });
      }

      if (this.selected === "b") {
        axios
          .post(
            "/share/Recipe/" +
              this.$route.params.id +
              "?groupId=" +
              this.GroupChosenId +
              "&right=" +
              this.right,
            null,
            { withCredentials: true }
          )
          .then((response) => {
            this.recipeID = 0;
            this.GroupChosenId = "";
            this.value1 = "";
            this.right = null;
            this.notFoundUserAlert = false;
            this.emptyRightAlert = false;
            this.emptyLoginAlert = false;
            this.selected = "a";
            this.$bvModal.hide("modal-prevent-closing");
            this.$bvModal.show("modal-2");
          });
      }
    },
    showMsgDelete(recId, recTitle) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete this recipe.", {
          title: "Are you sure you want to delete " + recTitle + "?",
          size: "bg",
          buttonSize: "bg",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.deleteRecipe(recId);
          } else {
          }
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },
    deleteRecipe(recipeId) {
      this.$store.dispatch("deleteRecipeEntity", recipeId).then((data) => {
        this.$router.push({ name: "recipes" });
      });
    },
    getIngredientKey(ingredient) {
      // generate a unique key
      if (ingredient.recipe === undefined) {
        return "resource_" + ingredient.resource.id;
      } else if (ingredient.resource === undefined) {
        return "recipe_" + ingredient.recipe.id;
      }
    },
    getChallengesKey(challenge) {
      // generate a unique key
      return "challenge-" + challenge.description.replace(/ /g, "-");
    },
    getOutputKey(output) {
      // generate a unique key
      return "output-" + output.resource.description.replace(/ /g, "-");
    },
    isLastObject(array, currentIndex) {
      return currentIndex === Object.keys(array).length - 1;
    },
  },
};
</script>

<style scoped>
.border-custom-lgr {
  border: 1px solid #d3d3d366;
}

#description-container {
  min-height: 80px !important;
}

.min-h-250 {
  min-height: 250px !important;
}

.col-container {
  border-left: 1px solid #d3d3d366;
  border-top: 1px solid #d3d3d366;
  border-bottom: 1px solid #d3d3d366;
  border-right: 10px solid #f7f7f7;
}

#image-container {
  min-height: 300px !important;
}

.media-wrapper {
  width: 64px;
  height: 64px;
}

.pre-formatted {
  white-space: pre;
}
</style>



// WEBPACK FOOTER //
// src/views/RecipeView.vue